module.exports = __webpack_public_path__ + "img/logo.b6dbad66.png";